import { MenuItem } from '@/interfaces/menuItem';

/**
 * Buduje menu nawigacji
 *
 * @export
 * @param {any[]} routes
 * @param {string} [query]
 * @returns {Promise<any[]>}
 */
export function buildMenu(routes: any[], query?: string, extraItems: MenuItem[] = []): MenuItem[] {
  const menuRoutes = routes.filter(route => route.meta && route.meta.menu);
  const allMenuItems: MenuItem[] = [...menuRoutes.map(route => routeToMenuItem(route, query)), ...extraItems];
  return filterQueriedMenuItems(allMenuItems);
}

/**
 * Mapuje element routera na element menu
 *
 * @param {*} route
 * @param {string} [query]
 * @returns {Promise<MenuItem>}
 */
export function routeToMenuItem(route: any, query?: string, mapChildren = true): MenuItem {
  const menuItem = { name: route.name, ...route.meta.menu };
  if (route.children && route.children.length && mapChildren) {
    const children = buildMenu(route.children, query);
    if (children.length) {
      menuItem.children = children;
    }
  }
  return menuItem;
}

/**
 * Odfiltrowuje elementy niepasujące do wyszukania
 *
 * @param {MenuItem[]} menuItems
 * @param {string} [query]
 * @returns {MenuItem[]}
 */
function filterQueriedMenuItems(menuItems: MenuItem[], query?: string): MenuItem[] {
  return menuItems.filter(
    menuItem =>
      !query ||
      (menuItem.children && menuItem.children.length) ||
      menuItem.title.toLowerCase().includes(query.toLowerCase())
  );
}
